import { Observable } from 'rxjs/Observable';

import { AppUiActions } from '../actions';

export interface IAppUiState {
    loading: boolean;
    isLockScreenVisible: boolean;
    isExitScreenVisible: boolean;
    isPauseScreenVisible: boolean;
    isNavigationModalVisible: boolean;
    genericPage: PgRendererDto.GenericPage;
}

const initialState: IAppUiState = {
    loading: false,
    isLockScreenVisible: false,
    isExitScreenVisible: false,
    isPauseScreenVisible: false,
    isNavigationModalVisible: false,
    genericPage: {
        title: null,
        content: null,
        visible: false,
        isNonRecoverable: false
    }
};

export function appUiReducer(state = initialState, action: AppUiActions.All): IAppUiState {
    switch (action.type) {
        case AppUiActions.HIDE_LOADING_OVERLAY:
            return Object.assign({}, state, { loading: false });

        case AppUiActions.SHOW_LOADING_OVERLAY:
            return Object.assign({}, state, { loading: true });

        case AppUiActions.HIDE_LOCK_SCREEN:
            return Object.assign({}, state, { isLockScreenVisible: false });

        case AppUiActions.SHOW_LOCK_SCREEN:
            return Object.assign({}, state, { isLockScreenVisible: true });

        case AppUiActions.SHOW_EXIT_SCREEN:
            return Object.assign({}, state, { isExitScreenVisible: true });

        case AppUiActions.HIDE_EXIT_SCREEN:
            return Object.assign({}, state, { isExitScreenVisible: false });

        case AppUiActions.HIDE_PAUSE_SCREEN:
            return Object.assign({}, state, { isPauseScreenVisible: false });

        case AppUiActions.SHOW_PAUSE_SCREEN:
            return Object.assign({}, state, { isPauseScreenVisible: true });

        case AppUiActions.SHOW_GENERIC_PAGE:
            return Object.assign({}, state, { genericPage: action.payload });

        case AppUiActions.HIDE_GENERIC_PAGE:
            return Object.assign({}, state, { genericPage: {
                title: null,
                content: null,
                visible: false,
                isNonRecoverable: false
            }});

        case AppUiActions.TOGGLE_NAVIGATION_MODAL_VISIBILITY:
            return Object.assign({}, state, { isNavigationModalVisible: action.visible });

        default:
            return state;
    }
}

export const getIsLoading = (state: IAppUiState) => state.loading;
export const getIsLockScreenVisible = (state: IAppUiState) => state.isLockScreenVisible;
export const getIsExitScreenVisible = (state: IAppUiState) => state.isExitScreenVisible;
export const getIsPauseScreenVisible = (state: IAppUiState) => state.isPauseScreenVisible;
export const getGenericPage = (state: IAppUiState) => state.genericPage;
export const getIsNavigationModalVisible = (state: IAppUiState) => state.isNavigationModalVisible;



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/reducers/app-ui.reducer.ts